// extracted by mini-css-extract-plugin
export default {"menuContainer":"menuContainer__xmY77","signupButton":"signupButton__vziLb","menuDrop":"menuDrop__nnBNT","burgerBtn":"burgerBtn__4RfFk"};